'use strict';

/**
 * Do not edit directly, this file was auto-generated.
 */

var lightDesktop = {
  "theme": "light-desktop",
  "type": {
    "family": {
      "base": "Mulish",
      "decorative": "Mulish"
    }
  },
  "radius": {
    "background": {
      "medium": "8px",
      "xsmall": "3px",
      "rounded": "300px",
      "small": "4px",
      "large": "16px",
      "xlarge": "32px"
    },
    "surface": {
      "medium": "8px",
      "small": "4px",
      "large": "16px",
      "xlarge": "32px"
    }
  },
  "borderWeight": {
    "xsmall": "1px",
    "small": "1.5px",
    "medium": "2px"
  },
  "size": {
    "height": {
      "100": "1px",
      "200": "8px",
      "350": "12px",
      "400": "16px",
      "450": "18px",
      "500": "20px",
      "600": "24px",
      "700": "28px",
      "850": "34px",
      "1050": "44px",
      "1300": "52px",
      "1400": "56px"
    },
    "width": {
      "100": "1px",
      "200": "8px",
      "350": "12px",
      "400": "16px",
      "450": "18px",
      "500": "20px",
      "600": "24px",
      "700": "28px",
      "850": "34px",
      "1050": "44px",
      "1300": "52px",
      "1400": "56px"
    }
  },
  "padding": {
    "dynamic": {
      "200": "8px",
      "400": "16px",
      "600": "24px",
      "800": "32px",
      "1000": "40px",
      "1200": "48px"
    },
    "static": {
      "100": "4px",
      "200": "8px",
      "300": "12px",
      "400": "16px",
      "500": "20px",
      "600": "24px",
      "800": "32px",
      "1000": "40px",
      "1200": "48px",
      "1400": "56px",
      "1600": "64px"
    }
  },
  "gap": {
    "0": "0px",
    "25": "1px",
    "50": "2px",
    "100": "4px",
    "200": "8px",
    "300": "12px",
    "400": "16px",
    "500": "20px",
    "600": "24px",
    "800": "32px",
    "1600": "64px"
  },
  "effect": {
    "elevation": {
      "overlay": "#ffffff",
      "overflow": {
        "x": "0px",
        "y": "-2px",
        "blur": "8px",
        "spread": "0px",
        "opacity": "16px",
        "colour": "#36485c29"
      },
      "raised": {
        "x": "0px",
        "y": "2px",
        "blur": "6px",
        "spread": "0px",
        "opacity": "16px",
        "colour": "#36485c29"
      }
    },
    "state": {
      "disabled": {
        "opacity": "0.5"
      },
      "readOnly": {
        "opacity": "0.8"
      },
      "hovered": {
        "background": "#00000014",
        "text": "#00000014",
        "icon": "#00000014",
        "border": "#00000014",
        "borderBold": "#00000052",
        "inverse": {
          "background": "#ffffff14",
          "text": "#ffffff14",
          "icon": "#ffffff14",
          "border": "#ffffff14",
          "borderBold": "#ffffff52",
          "backgroundBold": "#ffffff29"
        },
        "backgroundBold": "#00000029",
        "textBold": "#00000029",
        "iconBold": "#00000029",
        "backgroundBold2": "#00000029"
      },
      "pressed": {
        "background": "#00000029",
        "text": "#00000029",
        "icon": "#00000029",
        "border": "#00000029",
        "borderBold": "#000000cc",
        "inverse": {
          "background": "#ffffff29",
          "text": "#ffffff29",
          "icon": "#ffffff29",
          "border": "#ffffff29",
          "borderBold": "#ffffffcc"
        },
        "backgroundBold": "#00000052",
        "textBold": "#00000052",
        "iconBold": "#00000052"
      }
    },
    "focused": {
      "stroke": "2px",
      "border": "#015fcc"
    }
  },
  "surface": {
    "overlayBackdrop": "#00000033",
    "overlayInverted": "#2e3a47",
    "overlay": "#ffffff",
    "level0": "#ffffff",
    "level1": "#f5f7fa",
    "raised": "#ffffff",
    "overflow": "#ffffff",
    "inverse": "#2e3a47"
  },
  "brand": {
    "google": {
      "button": {
        "text": "#1f1f1f",
        "border": "#747775",
        "fill": "#ffffff"
      }
    },
    "fullscript": {
      "logo": "#88b04b"
    },
    "facebook": {
      "logo": "#3c5a99"
    },
    "linkedin": {
      "logo": "#2867b2"
    },
    "apple": {
      "button": {
        "text": "#000000",
        "border": "#000000",
        "fill": "#ffffff"
      }
    },
    "twitterX": {
      "logo": "#000000"
    }
  },
  "inverse": {
    "textBold": "#ffffff",
    "backgroundMuted": "#36485c",
    "icon": "#f5f7fa",
    "border": "#212933",
    "text": "#f5f7fa",
    "backgroundBold": "#212933"
  },
  "neutral": {
    "textBold": "#2e3a47",
    "backgroundLevel1": "#f5f7fa",
    "icon": "#36485c",
    "borderMuted": "#f5f7fa",
    "text": "#36485c",
    "backgroundLevel0": "#ffffff",
    "border": "#b8c6d6",
    "textSubtle": "#475a70",
    "borderBold": "#596d84",
    "backgroundLevel2": "#e6edf5",
    "divider": "#c8d3e0"
  },
  "critical": {
    "textBold": "#800d25",
    "border": "#af2645",
    "icon": "#980b29",
    "backgroundBold": "#af2645",
    "text": "#980b29",
    "backgroundLevel2": "#f0c4cd",
    "backgroundLevel1": "#feeef2"
  },
  "accent": {
    "green": {
      "text": "#275e43",
      "backgroundLevel1": "#ebf2ef",
      "icon": "#275e43",
      "textBold": "#244c38",
      "backgroundBold": "#307553",
      "border": "#307553",
      "backgroundLevel2": "#d1e0d9"
    },
    "orange": {
      "text": "#8e4d14",
      "textBold": "#784213",
      "icon": "#8e4d14",
      "backgroundLevel1": "#fff3e8",
      "backgroundBold": "#8e4d14",
      "border": "#b4631d",
      "backgroundLevel2": "#f3d8c0"
    },
    "blue": {
      "text": "#21588f",
      "textBold": "#194673",
      "icon": "#21588f",
      "backgroundLevel1": "#e6f1fc",
      "backgroundBold": "#3971a8",
      "border": "#3971a8",
      "backgroundLevel2": "#c0d8f0"
    },
    "red": {
      "text": "#980b29",
      "textBold": "#800d25",
      "icon": "#980b29",
      "backgroundLevel1": "#feeef2",
      "backgroundBold": "#af2645",
      "border": "#af2645",
      "backgroundLevel2": "#f0c4cd"
    },
    "purple": {
      "text": "#3b2566",
      "textBold": "#2a174f",
      "icon": "#3b2566",
      "backgroundLevel1": "#f2ecfe",
      "backgroundBold": "#533e7d",
      "border": "#533e7d",
      "backgroundLevel2": "#d7cee9"
    }
  },
  "discovery": {
    "textBold": "#5e4d27",
    "backgroundLevel1": "#f6f1e5",
    "text": "#72623e",
    "border": "#9e8c61",
    "backgroundBold": "#9e8c61",
    "icon": "#72623e",
    "backgroundLevel2": "#e9e1ce"
  },
  "recur": {
    "border": "#533e7d",
    "backgroundLevel1": "#f2ecfe",
    "backgroundBold": "#533e7d",
    "text": "#3b2566",
    "textBold": "#2a174f",
    "icon": "#3b2566",
    "backgroundLevel2": "#d7cee9"
  },
  "success": {
    "backgroundLevel2": "#d1e0d9",
    "textBold": "#244c38",
    "icon": "#275e43",
    "backgroundBold": "#307553",
    "text": "#275e43",
    "backgroundLevel1": "#ebf2ef",
    "border": "#307553"
  },
  "warning": {
    "backgroundLevel2": "#f3d8c0",
    "textBold": "#784213",
    "icon": "#8e4d14",
    "backgroundBold": "#8e4d14",
    "text": "#8e4d14",
    "backgroundLevel1": "#fff3e8",
    "border": "#b4631d"
  },
  "info": {
    "backgroundLevel2": "#c0d8f0",
    "textBold": "#194673",
    "icon": "#21588f",
    "backgroundBold": "#3971a8",
    "text": "#21588f",
    "backgroundLevel1": "#e6f1fc",
    "border": "#3971a8"
  },
  "smart": {
    "backgroundBold1": "#7495b9",
    "backgroundBold2": "#4d7199",
    "backgroundBold3": "#2e5988"
  },
  "asset": {
    "green": {
      "100": "#fafffc",
      "200": "#ebf2ef",
      "300": "#d1e0d9",
      "400": "#b6cfc2",
      "500": "#86b09b",
      "600": "#307553",
      "700": "#275e43",
      "800": "#244c38",
      "900": "#0f3d26",
      "background": "#d1e0d9",
      "backItem": "#86b09b"
    },
    "red": {
      "100": "#fff7f9",
      "200": "#feeef2",
      "300": "#f0c4cd",
      "400": "#e296a6",
      "500": "#c6516a",
      "600": "#af2645",
      "700": "#980b29",
      "800": "#800d25",
      "900": "#68182a",
      "background": "#f0c4cd",
      "backItem": "#c6516a"
    },
    "purple": {
      "100": "#fcfaff",
      "200": "#f2ecfe",
      "300": "#d7cee9",
      "400": "#b9abd5",
      "500": "#8471ab",
      "600": "#533e7d",
      "700": "#3b2566",
      "800": "#2a174f",
      "900": "#17043e",
      "background": "#d7cee9",
      "backItem": "#8471ab"
    },
    "orange": {
      "100": "#fffaf5",
      "200": "#fff3e8",
      "300": "#f3d8c0",
      "400": "#e7b88f",
      "500": "#cf8545",
      "600": "#b4631d",
      "700": "#8e4d14",
      "800": "#784213",
      "900": "#693a11",
      "background": "#f3d8c0",
      "backItem": "#cf8545"
    },
    "blue": {
      "100": "#f5faff",
      "200": "#e6f1fc",
      "300": "#c0d8f0",
      "400": "#88b1d9",
      "500": "#5d96cf",
      "600": "#3971a8",
      "700": "#21588f",
      "800": "#194673",
      "900": "#143657",
      "background": "#c0d8f0",
      "backItem": "#5d96cf"
    },
    "grey": {
      "100": "#fcfeff",
      "200": "#f5f7fa",
      "300": "#e6edf5",
      "400": "#e6edf5",
      "500": "#596d84",
      "600": "#475a70",
      "700": "#36485c",
      "800": "#2e3a47",
      "900": "#212933",
      "background": "#c8d3e0",
      "backItem": "#596d84"
    },
    "sand": {
      "100": "#ffffff",
      "200": "#f6f1e5",
      "300": "#e9e1ce",
      "400": "#d9cdb0",
      "500": "#c1af86",
      "600": "#9e8c61",
      "700": "#72623e",
      "800": "#5e4d27",
      "900": "#3e3114",
      "background": "#e9e1ce",
      "backItem": "#c1af86"
    },
    "shade": {
      "white": "#ffffff"
    }
  },
  "weight": {
    "regular": "400",
    "medium": "500",
    "bold": "700",
    "semibold": "600"
  },
  "letterSpacing": {
    "caption": "0px",
    "h1": "-0.4px",
    "h2": "-0.4px",
    "h3": "-0.4px",
    "h4": "-0.4px",
    "h5": "-0.4px",
    "body": "-0.2px",
    "callout": "-0.2px",
    "footnote": "-0.1px",
    "subcaption": "0.1px",
    "smallest": "0.1px"
  },
  "lineHeight": {
    "h1": "40px",
    "h2": "32px",
    "h3": "32px",
    "h4": "24px",
    "h5": "24px",
    "body": "24px",
    "footnote": "20px",
    "callout": "20px",
    "caption": "16px",
    "subcaption": "16px",
    "smallest": "18px"
  },
  "textSize": {
    "h1": "28px",
    "h2": "24px",
    "h3": "20px",
    "h4": "19px",
    "h5": "17px",
    "body": "16px",
    "callout": "15px",
    "footnote": "13px",
    "caption": "12px",
    "subcaption": "11px",
    "smallest": "9px"
  },
  "button": {
    "gap": "8px",
    "borderRadius": "8px",
    "height": {
      "small": "34px",
      "medium": "44px",
      "large": "52px"
    },
    "borderWeight": "1px",
    "paddingX": {
      "small": "16px"
    },
    "primary": {
      "neutral": {
        "text": "#ffffff",
        "background": "#36485c",
        "icon": "#f5f7fa"
      },
      "inverse": {
        "text": "#2e3a47",
        "background": "#f5f7fa",
        "icon": "#36485c"
      },
      "smart": {
        "text": "#ffffff",
        "icon": "#f5f7fa"
      },
      "critical": {
        "text": "#ffffff",
        "background": "#af2645",
        "icon": "#f5f7fa"
      }
    },
    "secondary": {
      "neutral": {
        "text": "#2e3a47",
        "border": "#212933",
        "icon": "#36485c"
      },
      "inverse": {
        "text": "#ffffff",
        "border": "#f5f7fa",
        "icon": "#f5f7fa"
      },
      "smart": {
        "text": "#2e3a47",
        "icon": "#36485c",
        "textAlt": "#ffffff",
        "iconAlt": "#ffffff"
      },
      "critical": {
        "text": "#800d25",
        "border": "#af2645",
        "icon": "#980b29",
        "textAlt": "#ffffff",
        "background": "#af2645",
        "iconAlt": "#f5f7fa"
      }
    },
    "tertiary": {
      "neutral": {
        "text": "#2e3a47",
        "icon": "#36485c"
      },
      "inverse": {
        "text": "#ffffff",
        "icon": "#f5f7fa"
      }
    }
  },
  "iconButton": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "width": {
      "small": "34px",
      "medium": "44px",
      "large": "52px"
    },
    "height": {
      "small": "34px",
      "medium": "44px",
      "large": "52px"
    },
    "primary": {
      "neutral": {
        "background": "#36485c",
        "icon": "#f5f7fa"
      },
      "inverse": {
        "background": "#f5f7fa",
        "icon": "#36485c"
      },
      "smart": {
        "icon": "#f5f7fa"
      },
      "critical": {
        "icon": "#f5f7fa",
        "background": "#af2645"
      }
    },
    "secondary": {
      "neutral": {
        "border": "#212933",
        "icon": "#36485c"
      },
      "inverse": {
        "border": "#f5f7fa",
        "icon": "#f5f7fa"
      },
      "smart": {
        "icon": "#36485c",
        "iconAlt": "#f5f7fa"
      },
      "critical": {
        "border": "#af2645",
        "icon": "#980b29",
        "background": "#af2645",
        "iconAlt": "#f5f7fa"
      }
    },
    "tertiary": {
      "neutral": {
        "icon": "#36485c"
      },
      "inverse": {
        "icon": "#f5f7fa"
      }
    }
  },
  "box": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "paddingX": {
      "xsmall": "8px",
      "small": "16px",
      "large": "32px"
    },
    "paddingY": {
      "xsmall": "8px",
      "small": "16px",
      "large": "32px"
    },
    "neutral": {
      "border": "#b8c6d6",
      "background": "#f5f7fa"
    },
    "alternate": {
      "border": "#b8c6d6",
      "background": "#ffffff"
    },
    "discovery": {
      "border": "#9e8c61",
      "background": "#f6f1e5"
    },
    "recur": {
      "border": "#533e7d",
      "background": "#f2ecfe"
    },
    "slot": {
      "text": "#2e3a47",
      "border": "#b8c6d6",
      "icon": "#36485c"
    }
  },
  "checkbox": {
    "borderRadius": "3px",
    "borderWeight": "1.5px",
    "width": {
      "small": "18px",
      "large": "34px"
    },
    "height": {
      "small": "18px",
      "large": "34px"
    },
    "gap": "2px",
    "text": "#36485c",
    "border": "#596d84",
    "icon": "#f5f7fa",
    "background": {
      "selected": "#212933",
      "default": "#ffffff"
    }
  },
  "actionTile": {
    "paddingTop": "16px",
    "borderRadius": "8px",
    "paddingRight": "8px",
    "paddingLeft": "8px",
    "paddingBottom": "16px",
    "defaultAlt": {
      "background": "#ffffff",
      "border": "#b8c6d6",
      "textHeading": "#2e3a47",
      "textBody": "#36485c"
    },
    "discovery": {
      "textHeading": "#5e4d27",
      "background": "#f6f1e5",
      "textBody": "#72623e"
    },
    "accentGreen": {
      "textBody": "#275e43",
      "background": "#ebf2ef",
      "textHeading": "#244c38"
    },
    "default": {
      "textBody": "#36485c",
      "background": "#f5f7fa",
      "textHeading": "#2e3a47"
    }
  },
  "search": {
    "gap": "8px",
    "borderRadius": "8px",
    "borderWeight": "1px",
    "paddingX": "16px",
    "height": {
      "medium": "44px",
      "large": "52px",
      "small": "24px"
    },
    "width": {
      "small": "24px"
    },
    "text": "#36485c",
    "border": "#b8c6d6",
    "background": "#ffffff",
    "icon": "#36485c"
  },
  "accordion": {
    "borderRadius": "8px",
    "textHeading": "#2e3a47",
    "textSubheading": "#36485c",
    "border": "#b8c6d6",
    "textBody": "#36485c",
    "icon": "#36485c"
  },
  "link": {
    "gap": "4px",
    "accentGreen": {
      "text": "#275e43",
      "icon": "#275e43"
    },
    "neutral": {
      "text": "#36485c",
      "icon": "#36485c"
    },
    "inverse": {
      "text": "#f5f7fa",
      "icon": "#f5f7fa"
    }
  },
  "input": {
    "borderRadius": "8px",
    "borderWeight": "1px",
    "gap": "16px",
    "paddingX": "16px",
    "height": {
      "large": "56px",
      "small": "28px"
    },
    "paddingY": "16px",
    "neutral": {
      "text": "#36485c",
      "border": "#b8c6d6",
      "icon": "#36485c"
    },
    "background": "#ffffff",
    "critical": {
      "text": "#980b29",
      "border": "#af2645",
      "icon": "#980b29"
    }
  },
  "radio": {
    "borderRadius": "300px",
    "borderWeight": "1.5px",
    "width": {
      "small": "20px",
      "large": "34px"
    },
    "height": {
      "small": "20px",
      "large": "34px"
    },
    "gap": "2px",
    "text": "#36485c",
    "border": "#596d84",
    "background": {
      "selected": "#212933",
      "default": "#ffffff"
    }
  },
  "status": {
    "height": {
      "large": "52px",
      "small": "34px",
      "medium": "44px"
    },
    "paddingX": {
      "small": "8px",
      "medium": "16px",
      "large": "16px"
    },
    "gap": "8px",
    "borderRadius": "4px",
    "icon": {
      "height": "8px",
      "width": "8px",
      "radius": "300px"
    },
    "neutral": {
      "background": "#e6edf5",
      "text": "#2e3a47",
      "icon": "#36485c"
    },
    "success": {
      "background": "#d1e0d9",
      "text": "#244c38",
      "icon": "#275e43"
    },
    "warning": {
      "background": "#f3d8c0",
      "text": "#784213",
      "icon": "#8e4d14"
    },
    "critical": {
      "background": "#f0c4cd",
      "text": "#800d25",
      "icon": "#980b29"
    },
    "info": {
      "background": "#c0d8f0",
      "text": "#194673",
      "icon": "#21588f"
    }
  },
  "divider": {
    "borderWeight": "1px",
    "gap": "8px",
    "text": "#475a70"
  },
  "pill": {
    "gap": "4px",
    "paddingX": {
      "xsmall": "4px",
      "small": "8px",
      "medium": "12px"
    },
    "height": {
      "xsmall": "16px",
      "small": "24px",
      "medium": "28px"
    },
    "radius": "300px",
    "neutral": {
      "text": "#36485c",
      "background": "#e6edf5",
      "icon": "#36485c"
    },
    "success": {
      "text": "#275e43",
      "background": "#d1e0d9",
      "icon": "#275e43"
    },
    "critical": {
      "text": "#980b29",
      "background": "#f0c4cd",
      "icon": "#980b29"
    },
    "warning": {
      "text": "#8e4d14",
      "background": "#f3d8c0",
      "icon": "#8e4d14"
    },
    "discovery": {
      "text": "#72623e",
      "background": "#e9e1ce",
      "icon": "#72623e"
    },
    "recur": {
      "text": "#3b2566",
      "background": "#d7cee9",
      "icon": "#3b2566"
    },
    "info": {
      "text": "#21588f",
      "background": "#c0d8f0",
      "icon": "#21588f"
    }
  },
  "snackbar": {
    "textHeading": "#ffffff",
    "textBody": "#f5f7fa",
    "surface": "#2e3a47"
  },
  "drawer": {
    "textBody": "#36485c",
    "textFootnote": "#475a70",
    "textHeading": "#2e3a47",
    "surface": "#ffffff"
  },
  "menu": {
    "textHeading": "#2e3a47",
    "textFootnote": "#475a70",
    "surface": "#ffffff",
    "textBody": "#36485c"
  },
  "popovers": {
    "textBody": "#36485c",
    "textFootnote": "#475a70",
    "surface": "#ffffff",
    "textHeading": "#2e3a47"
  },
  "tooltip": {
    "surface": "#2e3a47",
    "textHeading": "#ffffff",
    "textBody": "#f5f7fa"
  },
  "bottomSheet": {
    "textFootnote": "#475a70",
    "textBody": "#36485c",
    "surface": "#ffffff",
    "textHeading": "#2e3a47"
  },
  "showMoreAccordion": {
    "icon": "#36485c",
    "text": "#2e3a47"
  },
  "modal": {
    "textFootnote": "#475a70",
    "surface": "#ffffff",
    "textBody": "#36485c",
    "textHeading": "#2e3a47"
  },
  "dotBadge": {
    "default": "#36485c",
    "warning": "#8e4d14",
    "info": "#3971a8",
    "recur": "#533e7d",
    "success": "#307553",
    "critical": "#af2645",
    "inverse": "#f5f7fa",
    "discover": "#9e8c61"
  }
};

exports.lightDesktop = lightDesktop;
//# sourceMappingURL=light-desktop.cjs.map
